export const capturePromiseRejection = {
  initialize(sentry) {
    return (rejection = {}) => {
      rejection && rejection.preventDefault && rejection.preventDefault()
      let reason = rejection && (rejection.reason || rejection.message)
      console.log(`!!! ERROR (capturePromiseRejection) Promise was rejected. Reason: ${reason}`)
      console.log(rejection)

      sentry && sentry.captureException(rejection)
    }
  }
}
